import { Tab, Tabs } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import VacationSettings from './vacationSettings';
import VacationTypes from './vacationTypes';

const VacationSettingTabs = (props) => {
    const { t, handleUserDataChange } = props;

    return (
        <Tabs defaultActiveKey="vacationSettings" id="MainTabContainer">
            <Tab eventKey="vacationSettings" title={t('Vacation Settings')}>
                <VacationSettings
                    handleUserDataChange={handleUserDataChange}
                />
            </Tab>
            <Tab eventKey="vacationTypes" title={t('Vacation Types')}>
                <VacationTypes />
            </Tab>
        </Tabs>
    )
}

export default withLocalization(VacationSettingTabs);